import { FC, useState, useEffect } from "react";
import StayCardAlternative from "components/StayCard/StayCardAlternative";
import SectionDateRangeSkeleton from "components/calendar/BookingCalendatSkeleton";
import axios from "axios";
import { useClient } from "ClientContext";
import { getDisabledDates } from "utils/getAvailabilitiesConversion";

export interface SectionGridHasMapProps {
  listings: any;
}

interface availabilitiesProps {
  id: string;
}

const AlternativeGrid: FC<SectionGridHasMapProps> = ({ listings }) => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const { internal_ID, integration_TYPE,actions } = useClient();
  const [availabilities, setAvailabilities] = useState<{
    [key: string]: availabilitiesProps;
  }>({});
  const [loading, setLoading] = useState(true);

  const fromDate = new Date(); // Today's date
  const toDate = new Date(); // Create a new date object for 12 months ahead

  // Add 12 months to the current date
  toDate.setMonth(toDate.getMonth() + 12);

  // Function to fetch availabilities for a single listing using axios and POST request
  const fetchAvailabilities = async (id: string) => {
    try {
      const response = await axios.post(
        `${SERVER_URL}/api/controller`,
        {
          action: actions.fetchAvailabilities,
          internal_ID: internal_ID,

          params: {
            listingId: id,
            availabilities: {
              fromDate: fromDate.toISOString(),
              toDate: toDate.toISOString(),
            },
          },
        } // Send the id as the body of the POST request
      );
      let Availabilities = { availabilities: response.data };
      let availableDates = await getDisabledDates(
        Availabilities,
        integration_TYPE
      );
      return availableDates;
    } catch (error) {
      console.error(`Error fetching availabilities for id ${id}:`, error);
      return null;
    }
  };

  // Function to fetch availabilities for all listings
  const fetchAllAvailabilities = async () => {
    if (!listings || listings.length === 0) {
      setLoading(false);
      return;
    }

    const results: { [key: string]: any } = {};

    for (const item of listings) {
      const availability = await fetchAvailabilities(item.id);
      if (availability) {
        results[item.id] = availability;
      }
    }

    setAvailabilities(results);
    setLoading(false);
  };

  useEffect(() => {
    fetchAllAvailabilities();
  }, [listings]);

  return (
    <div>
      <div className="relative flex min-h-screen">
        {/* CARDSSSS */}
        <div className="min-h-screen w-full flex-shrink-0 xl:px-8 ">
          <div className="grid grid-cols-1 gap-8">
            {loading && <>loading</>}
            {!loading &&
              listings.map((item: any) => (
                <div key={item.id}>
                  <StayCardAlternative
                    data={item}
                    availabilities={availabilities[item.id] || []} // Pass the fetched availabilities
                  />
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AlternativeGrid;
